module.exports = __webpack_public_path__ + "img/show.40f25a1a.svg";